export const deletedVehiclesDashboard =
  'https://app.lightdash.cloud/projects/fcfb1caa-7ec1-408a-97fa-8c84eed4c8e0/dashboards/e5006f8a-ffc3-44e5-a511-29de0a464c9a/';
